<template>
  <div class="container-block" style="margin: 15px 0">
    <p>
      <span style="font-size: 16px;margin-right: 5px;font-weight: bold;">额外添加原料</span>
      <a-tooltip>
        <template slot="title">
          额外添加的原料比例≤盘重的5%
        </template>
        <a-icon type="exclamation-circle" />
      </a-tooltip>

    </p>
    <a-table :columns="columns" :scroll="{x: 680,y:500}" :data-source="list" rowKey='name' :pagination="false">
      <template slot="fixed3" slot-scope="t">
        {{ t || t === 0 ? Number(t).toFixed(3) : t }}
      </template>
      <a-tooltip slot="tips" slot-scope="t">
        <template slot="title">
          {{ t }}
        </template>
        {{ t }}
      </a-tooltip>
      <a-tooltip slot="rawName" slot-scope="text,record"  style="display: flex; positon: relative">
        <img v-if="record.status === 1"
             style="width: 26px; position: absolute; top: 0; left: 0"
             src="../../../assets/images/shixiao.svg"
        />
        <div v-if="record.status === 1" style="width: 22px"></div>
        {{text}}
      </a-tooltip>
    </a-table>
  </div>
</template>
<script>
export default {
  props:{
    rowId:{
      type: String,
      default: ''
    },
    // factoryId:{
    //   type: String,
    //   default: ''
    // }
  },
  data(){
    return{
      factoryId: window.localStorage.getItem('factoryId'),
      list:[],
      pagination: {
        total:0,
        pageSize:10000,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      columns: [
        {
          title: '原料名称',
          dataIndex: 'rawName',
          width: 150,
          ellipsis: true,
          scopedSlots: {customRender: 'rawName'},
        },
        {
          title: '原料代码',
          dataIndex: 'rawCode',
          width: 120,
          ellipsis: true,
          scopedSlots: {customRender: 'tips'},
        },
        {
          title: '用量(%)',
          dataIndex: 'percentage',
          scopedSlots: {customRender: 'fixed3'},
          width: 100,
          ellipsis: true,
        },
        {
          title: '用量(批次量)',
          dataIndex: 'uasge',
          scopedSlots: {customRender: 'fixed3'},
          width: 80,
          ellipsis: true,
        },
        {
          title: '单位',
          dataIndex: 'unit',
          width: 80,
          ellipsis: true,
          scopedSlots: {customRender: 'tips'},
        },
      ],
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    getList(){
      let params = {
        productId: this.rowId,
      }
      if(this.rowId){
        this.$http.get('/nhf-app/formularawextraproduct/getFormulaRawExtraProductList',{params}).then(res => {
          let {success,data} = res;
          if(success){
            this.list = data || []
          }else{
            this.$message.error('查询失败')
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.tableBox{
  padding: 0 20px;
}
</style>
